<!--suppress TypeScriptUnresolvedVariable -->
<div *ngIf="constructor.name.length > 1" class="component-name">>> {{constructor.name}} <<</div>

<div class="po-pdf">
    <div class="header">{{headerText}}</div>

    <div class="po-info">
        <table style="max-width: 400px; ">
            <tr class="bordered-row"><th *ngFor="let column of columns" [style.width]="column.widthPercent + '%'">{{column.title}}</th></tr>

            <tr class="bordered-row">
                <td [style.width]="columns[0].widthPercent + '%'" [style.textAlign]="'center'" rowspan="2">{{poManager.current.number}}</td>
                <td [style.width]="columns[1].widthPercent + '%'" [style.textAlign]="'center'">Converters</td>
                <td [style.width]="columns[2].widthPercent + '%'" [style.textAlign]="'center'">{{poManager.current.totalNumConverters}}</td>
                <td [style.width]="columns[3].widthPercent + '%'" [style.textAlign]="'center'">{{poManager.current.totalConvertersPrice | currency:poManager.current.currency:true}}</td>
                <td [style.width]="columns[4].widthPercent + '%'" [style.whiteSpace]="'nowrap'" [style.textAlign]="'center'" rowspan="2">{{poManager.current.totalPrice | currency:poManager.current.currency:true}}</td>
                <td [style.width]="columns[5].widthPercent + '%'" [style.textAlign]="'center'" >                            
                    <p-inputNumber [inputStyle]="{'width': '100px', 'backgroundColor': 'white', 'border': '1px solid gray'}" [(ngModel)]="poManager.current.catsAdjustment" (ngModelChange)="poManager.adjustmentChange()" inputId="currency-us" mode="currency" [currency]="userCurrency" locale="en-US" [ngModelOptions]="{standalone: true}" />
                </td>
                <td style="width: 15%; text-align: center; white-space: nowrap; padding: 0 10px" rowspan="2">{{poManager.current.totalAdjusted | currency:poManager.current.currency:true}}</td>
            </tr>
            <tr class="bordered-row">
                <!-- <td [style.width]="columns[0].widthPercent + '%'" [style.text-align]="'center'">{{poManager.current.number}}</td> -->
                <td [style.width]="columns[1].widthPercent + '%'" [style.text-align]="'center'">Non-Ferrous</td>
                <td [style.width]="columns[2].widthPercent + '%'" [style.text-align]="'center'">{{poManager.current.numMiscellaneous}}</td>
                <td [style.width]="columns[3].widthPercent + '%'" [style.text-align]="'center'">{{poManager.current.totalMiscPrice | currency:poManager.current.currency:true}}</td>
                <td [style.width]="columns[5].widthPercent + '%'" [style.textAlign]="'center'" >                            
                    <p-inputNumber [inputStyle]="{'width': '100px', 'backgroundColor': 'white', 'border': '1px solid gray'}" [(ngModel)]="poManager.current.nonFerrousAdjustment" (ngModelChange)="poManager.adjustmentChange()" inputId="currency-us" mode="currency" [currency]="userCurrency" locale="en-US" [ngModelOptions]="{standalone: true}" />
                </td>
                <!-- <td [style.width]="columns[4].widthPercent + '%'" [style.text-align]="'center'">{{poManager.current.adjustment | currency:poManager.current.currency:true}}</td> -->
            </tr>
        </table>
    </div>

    <ls-payment-types-selection [(selectedPaymentTypes)]="selectedPaymentTypes" />
    <div class="sellerSelected">
        <div>{{sellerInfoHeaderText}}</div>

        <div style="display: flex; flex-direction: row; align-items: center; gap: 8px;">
            <p-dropdown [options]="poManager.current.vendor.contacts" [(ngModel)]="selectedContact" [ngModelOptions]="{standalone: true}" optionLabel="fullName" placeholder="Select Contact"
                    (onChange)="onSelectedContactChanged($event)"></p-dropdown>
            <span style="color: red; font-size: .9rem" *ngIf="selectedContact != null && !contactValid">Contact data is incomplete</span>
        </div>
        <div class="multiple-fields">
            <div class="field-group">
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(idText)}}</span><input type="text" pInputText [(ngModel)]="idNum" [ngModelOptions]="{standalone: true}" [disabled]="true"/>
                </div>
            </div>
            <div class="field-group">
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(stateText)}}</span><input type="text" pInputText [(ngModel)]="idState" [ngModelOptions]="{standalone: true}" [disabled]="true"/>
                </div>
            </div>
        </div>
    </div>
    <ls-vehicle-info [makeOptional]="false" [modelOptional]="false" [colorOptional]="false" [numberOptional]="false" [stateOptional]="false" [selectedContact]="selectedContact"/>

    <div class="buyer-info">
        <div>{{buyerText}}</div>

        <div style="margin-top: 20px">
            <div>{{poManager.current.buyerName}}</div>
            <div>{{poManager.current.location.address}}</div>
            <div>{{poManager.current.location.city}}, {{poManager.current.location.state}}&nbsp;&nbsp;{{poManager.current.location.zip}}</div>
        </div>
    </div>

    <div class="declaration-area">
        <div>{{declaration1}}</div>
        <div>{{declaration2}}</div>
        <div>{{declaration3}}</div>
        <div>{{declaration4}}</div>
    </div>

    <div class="seller-info">
        <div>{{sellerInfoHeaderText}}</div>

        <div style="margin-top: 20px">
            <div>{{poManager.current.vendorName}}</div>
            <div>{{poManager.current.vendor.address}}</div>
            <div>{{poManager.current.vendor.city}}, {{poManager.current.vendor.state}}&nbsp;&nbsp;{{poManager.current.vendor.zip}}</div>
        </div>

        <div class="multi-signature-line tall signature">
            <div class="text">{{removeUnderscores(signatureText)}}</div>
            <div class="signature-auto-expand"><ls-capture-signature #signature></ls-capture-signature></div>
            <!-- <div class="field-group">
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(dateText)}}</span>
                    <p-calendar [(ngModel)]="date" [ngModelOptions]="{standalone: true}" [styleClass]="ThemeManager.theme" appendTo="body" inputStyleClass="calendar-input-style"></p-calendar>
                </div>
            </div> -->
        </div>

        <!-- <div class="field-group printed-name">
            <div class="p-inputgroup">
                <span>{{removeUnderscores(printText)}}</span><input type="text" pInputText [(ngModel)]="name" [ngModelOptions]="{standalone: true}" class="name"/>
            </div>
        </div> -->
        <div class="multiple-fields name-and-date">
            <div class="field-group">
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(printText)}}</span><input type="text" pInputText [(ngModel)]="this.poManager.current.print" [ngModelOptions]="{standalone: true}" class="name"/>
                </div>
            </div>
            <div class="field-group">
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(dateText)}}</span>
                    <p-calendar [(ngModel)]="this.poManager.current.purchaseDate" [showTime]="true" [ngModelOptions]="{standalone: true}" [styleClass]="ThemeManager.theme" appendTo="body" inputStyleClass="calendar-input-style"></p-calendar>
                </div>
            </div>
            <div class="field-group">
                <div class="p-inputgroup">
                    <span>Time Zone</span>
                    <p-dropdown [options]="timeZones" [(ngModel)]="selectedTimezone" [ngModelOptions]="{standalone: true}"
                        optionLabel="fullName" placeholder="Select Timezone"></p-dropdown>
                </div>
            </div>
        </div>
    </div>


    <div class="buttons">
        <div class="buttons-left">
            <p-button severity="secondary" (click)="clearSignatures()">Clear Signatures</p-button>
        </div>
        <div class="buttons-right">
            <p-button severity="secondary" (click)="onCancel()">Cancel</p-button>
            <p-button [disabled]="!poManager.current.vehicleInfoValid || selectedTimezone == null || !poManager.current.totalsValid || signature.isEmpty || poManager.current.print?.length === 0" (click)="onSave()">Confirm</p-button>
        </div>
    </div>
</div>
